"use strict";
exports.__esModule = true;
exports.isElementVisible = void 0;
function isElementVisible(activeElement, ancestorElement) {
    // this function takes two elements and determines if the activeElement
    // is *fully* visible in the field of view for the ancestorElement.
    // activeElement dimensions
    var offsetTop = activeElement.offsetTop, offsetHeight = activeElement.offsetHeight;
    var elementBottom = offsetHeight + offsetTop;
    // boundaries for the ancestorElement
    var containerTop = ancestorElement.scrollTop;
    var containerBottom = ancestorElement.scrollTop + ancestorElement.offsetHeight;
    var above = offsetTop < containerTop;
    var below = elementBottom > containerBottom;
    var topIsWithin = offsetTop >= containerTop && offsetTop < containerBottom;
    var bottomIsWithin = elementBottom <= containerBottom && elementBottom > containerTop;
    var visibility = {
        contained: !above && !below,
        above: above,
        below: below,
        topIsWithin: topIsWithin,
        bottomIsWithin: bottomIsWithin
    };
    return visibility;
}
exports.isElementVisible = isElementVisible;
//# sourceMappingURL=elements.js.map